"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TABLE_CATEGORY_KEY = 'base';
exports.TABLE_COMPONENT_KEY = 'table';